import { render, staticRenderFns } from "./MomentOfferedListComponent.vue?vue&type=template&id=992841f4&scoped=true&"
import script from "./MomentOfferedListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentOfferedListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentOfferedListComponent.vue?vue&type=style&index=0&id=992841f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992841f4",
  null
  
)

export default component.exports